// extracted by mini-css-extract-plugin
module.exports = {"button":"HeaderSearchBox_button__AWOKt","headerShadow":"HeaderSearchBox_headerShadow__2g9Nk","apply-shadow":"HeaderSearchBox_apply-shadow__f5Rhq"};